import { render, staticRenderFns } from "./m-menu.vue?vue&type=template&id=645a771f&scoped=true&"
import script from "./m-menu.vue?vue&type=script&lang=js&"
export * from "./m-menu.vue?vue&type=script&lang=js&"
import style0 from "./m-menu.vue?vue&type=style&index=0&id=645a771f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a771f",
  null
  
)

export default component.exports